import { createUseStyles } from 'react-jss'
import clsx from 'clsx'
import HTMLParser from 'react-html-parser'
import Grid from 'react-jss-grid'
import style from './style'

const useStyles = createUseStyles(style)

function TextBlock({ title, paragraph, theme }) {
  const classes = useStyles()

  return (
    <div className={clsx({
      [classes.text]: true,
      [classes.textDark]: theme === 'dark',
    })}
    >
      <Grid container>
        <Grid item xs={12}>
          {title ? (
            <h2>
              {HTMLParser(title)}
            </h2>
          ) : null}
          {paragraph ? HTMLParser(paragraph) : null}
        </Grid>
      </Grid>
    </div>
  )
}

export default TextBlock
